export default function Panel({children}) {
    return (
        <section
            className="relative flex flex-col sm:flex-row items-stretch max-w-[270px] sm:max-w-3xl mx-auto rounded-md overflow-hidden -translate-y-1/3 sm:-translate-y-1/2 shadow-xl -mb-24 sm:-mb-8 md:mb-8 z-20 will-change-transform">
            {children}
        </section>
    )
}